/**
 * Cometa Taller · Selector Accesible de Paleta (assets/src/paleta.js)
 *
 * Cumple con:
 * - Sección 5.3: Neón, Menta, Tiza con 3 muestras y filamentos reales.
 * - Requisitos del usuario:
 *   - <input type="radio"> con <label> navegable por teclado y foco visible.
 *   - Al cambiar paleta actualiza:
 *     1. Imagen de variación correspondiente
 *     2. Los tres puntos de color (muestras)
 *     3. La lista de filamentos reales en texto
 */

export function initPaleta() {
  const contenedores = document.querySelectorAll('[data-ct-selector-paleta]');

  contenedores.forEach((contenedor) => {
    const inputs = contenedor.querySelectorAll('input[type="radio"][name="paleta"]');
    const fotoPrincipal = document.querySelector('[data-ct-producto-foto-principal]');
    const filamentosTexto = document.querySelector('[data-ct-paleta-filamentos]');
    const nombrePaletaActual = document.querySelector('[data-ct-paleta-nombre-actual]');
    const puntosMuestras = document.querySelectorAll('[data-ct-muestra-punto]');

    function actualizarPaleta(input) {
      const nombre = input.getAttribute('data-nombre') || input.value;
      const imgUrl = input.getAttribute('data-img');
      const filamentos = input.getAttribute('data-filamentos');
      const c1 = input.getAttribute('data-c1');
      const c2 = input.getAttribute('data-c2');
      const c3 = input.getAttribute('data-c3');

      // 1. Actualizar imagen de la variación si está disponible
      if (fotoPrincipal && imgUrl) {
        fotoPrincipal.src = imgUrl;
        fotoPrincipal.alt = `Pieza en paleta ${nombre}`;
      }

      // 2. Actualizar nombre de la paleta
      if (nombrePaletaActual) {
        nombrePaletaActual.textContent = nombre;
      }

      // 3. Actualizar lista de filamentos reales
      if (filamentosTexto && filamentos) {
        filamentosTexto.textContent = filamentos;
      }

      // 4. Actualizar puntos de color si se requiere en los badges
      if (c1 && c2 && c3 && puntosMuestras.length >= 3) {
        if (puntosMuestras[0]) puntosMuestras[0].style.backgroundColor = c1;
        if (puntosMuestras[1]) puntosMuestras[1].style.backgroundColor = c2;
        if (puntosMuestras[2]) puntosMuestras[2].style.backgroundColor = c3;
      }

      // Disparar evento personalizado por si otros componentes escuchan
      contenedor.dispatchEvent(new CustomEvent('paletaCambiada', {
        bubbles: true,
        detail: { nombre, imgUrl, filamentos, c1, c2, c3 }
      }));
    }

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) {
          actualizarPaleta(input);
        }
      });

      // Si ya está chequeado de inicio, sincronizar
      if (input.checked) {
        actualizarPaleta(input);
      }
    });
  });
}
